<template>
  <div id="app">

    <router-view />
    <v-tabar></v-tabar>
  </div>
</template>

<script>
  import tabar from '@/components/tabar';
  import {
    mapGetters,
    mapActions
  } from "vuex";
  export default {
    name: 'App',
    components: {
      'v-tabar': tabar
    },
    watch: {
      // 如果路由有变化，会再次执行该方法
      '$route': 'showTitle'
    },

    methods: {
      ...mapActions({
        setUserInfo: "setUserInfo",
        setLogOut: "setLogOut"
      }),


      showTitle() {
        window.document.title = this.$route.name;
      }
    },
    computed: {
      ...mapGetters(["loginStatus", "userInfo"]),
    },
    mounted() {
      var now = new Date().getTime();
      var time = this.userInfo.TIME;
      var expiredate = time + 15 * 24 * 60 * 1000 * 60;
      if (now > expiredate) {
        this.setLogOut()
      }
    }
  }

</script>

<style lang="less">
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    // margin-bottom: 5em;
    background-color: #fff;


    .navbar {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      border-top: 1px solid #ccc;

      li {
        float: left;
        width: 25%;
        list-style: none;
      }

      i {
        font-size: 1.5rem;
      }

      h1 {
        font-size: 12px;
        font-weight: normal;
        margin-top: 0.3rem;
      }
    }
  }

  @media screen and (max-width: 320px) {
    #app {
      min-height: 568px
    }
  }

  @media screen and (min-width: 321px) and (max-width: 375px) {
    #app {
      min-height: 667px
    }
  }

  @media screen and (min-width: 376px) {
    #app {
      min-height: 736px
    }
  }

</style>



// WEBPACK FOOTER //
// src/App.vue